<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#fed602"
          v-bind="attrs"
          v-on="on"
        >
          NOVO VALOR
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Novo valor</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false">
                    mdi-close
                  </v-icon>
                </div>
              </v-col>
            </v-row>
             <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12">
                    <v-select
                      v-model="typeSelected"
                      :items="typeOptions"
                      item-text="exhibition_name"
                      item-value="id_custom_value_type"
                      label="Tipo de valor"
                      :rules="[rules.required]"
                      @change="changeType()"
                    >
                    </v-select>
                </v-col>
                <v-col cols="6" v-if="typeDate">
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    class="fluid"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="!typeValue"
                        :value="dateFormat"
                        label="Data"
                        :rules="[rules.required]"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable locale="pt-BR" :max="moment().format('YYYY-MM-DD')">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="datePicker = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.datePicker.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col :cols="typeDate ? '6':'12'">
                  <v-text-field label="Valor" v-model="price" :rules="[rules.required]" @keydown="onlyNumbers($event)" v-if="valueType == 'NUMERIC'"></v-text-field>
                  <v-text-field label="Valor" v-model="price" :rules="[rules.required]" v-else></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              color="#fed602"
              class="button-primary mr-4 mb-4"
              @click="createValue()"
            >
              <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
              <span v-else>Salvar</span>
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    computed: {
      dateFormat: function () {
        return  this.date ? moment(this.date).format('DD-MM-YYYY') : ''
      }
    },
    props: {
      channel: {
          type: Number,
          required: true,
          default: null
      }
    },
    created() {
      this.getTypeValue();
    },
    data: () => ({
      moment: moment,
      name: '',
      price: '',
      date: '',
      datePicker: false,
      typeDate: false,
      typeValue: '',
      loading: false,
      typeOptions: [],
      valueType: 'NUMERIC',
      typeSelected: '',
      notification: {
          active: false,
          description: '',
          type: '',
          closeText: ''
      },
      valid: true,
      rules: {
          required: value => !!value || 'Este campo é obrigatório.',
          min: v => v.length >= 6 || 'Sua senha precisa ter pelo menos 6 caracteres',
          email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
      },
      dialog: false
    }),
    methods: {
      changeType() {
        this.typeValue = this.typeOptions.filter(option => this.typeSelected == option.id_custom_value_type);
        this.typeDate = this.typeValue[0].need_date;
        this.valueType = this.typeValue[0].value_type;
        this.price = '';
      },
      getTypeValue() {
        this.$http.get( '/custom-value-type' )
        .then( ( res ) => {
          this.typeOptions = res.data;
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro na solicitação.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).finally( () => {
          this.loading = false;
        } );
      },
      createValue() {
        let params = {
          id_custom_value_type: this.typeSelected,
          value: this.valueType == 'NUMERIC' ? this.price.replace(',','.') : this.price
        };
        if (this.typeDate) {
          params = {
            id_custom_value_type: this.typeSelected,
            date: this.date,
            value: this.price.replace(',','.')
          }
        }
        this.$http.post( '/channel/'+this.channel+'/custom-value', params)
        .then( () => {
          this.notification = {
            active: true,
            description: 'Valor criado com sucesso.',
            type: 'success',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao cadastrar o valor, tente novamente.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        }) .finally(() => {
          this.loading = false,
          this.valid = true,
          this.dialog = false,
          this.reset();
          this.$emit("getData")
        })
      },
      onlyNumbers(e) {
        var charCode = e.keyCode;
        if (charCode != 8 && charCode != 9) {
          if (charCode != 188 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 106)) {
            e.preventDefault();
          }
          if (charCode == 188 && this.price.indexOf(',') != -1 ) {
            e.preventDefault();
          }
        }
      },
      reset () {
        this.$refs.form.reset()
      }
    }
  }
</script>